import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
// PrimeReact custom theme overrides (base theme imported in index.js)
import './theme/primeReactTheme.css';
import { Home } from './Pages/home';
import { Provider } from 'react-redux';
import store from './Redux';
import { updateSelectedHub } from './Redux/user';
import { Signup } from './Registrations/signup';
import { Login } from './Registrations/login';
import { DPLogin } from './Pages/delivery_partner_login';
import { DPHome } from './Pages/dp-home';
import { DeliveryEarnings } from './Components/delivery_earnings';
import { useEffect, useRef, useState} from 'react';
import { jwtDecode } from 'jwt-decode';
import { InventoryBatchList } from './Components/product_management/inventoryBatchList';
import { OtpVerification } from './Registrations/otp-verification';
import { Dashboard } from './Components/dashboard';
import { ProductDetails } from './Components/product_management/product_details';
import { Campaign } from './Components/product_management/campaign';
import { Inventory } from './Components/product_management/inventory';
import { AddHub } from './Components/product_management/AddHub';
import { VendorManagement } from './Components/vendor_management/VendorManagement';
import { BatchHistory } from './Components/product_management/batch_history';
import { GeneralSettings } from './Components/settings/general_settings';
import { Category } from './Components/settings/category_management';
import { SubCategory } from './Components/settings/sub_category_management';
import { OrederManagement } from './Components/order_management/order_lists';
import { OfferManagement } from './Components/offer_management/offer_details';
import { DeliveryManagement } from './Components/delivery_management/delivery_management';
import { WeeklyDeliverySlots } from './Components/delivery_management/weekly_delivery_slots';
import { Suppliers } from './Components/supplier_management/suppliers';
import { AddSupplier } from './Components/supplier_management/AddSupplier.js';
import { UserManagement } from './Components/user_management';
import { Campaign_Push_notification } from './Components/campaign/campaign_push_notification';
import { AppVersionControlSettings } from './Components/settings/app_version_control';
import ProductBanner from './Components/product_management/product_banner';
import {AddInstructions} from './Components/settings/AddInstructions';
import { FranchiseManagement } from './Components/product_management/franchise';
import Homebanner from './Components/product_management/home_banner';
import ProfileSettings from './Components/settings/profile_settings';
import LaunchScreenSettings from './Components/settings/launch_screen';
import KioskOrderManagement from './Components/kiosk_order_placement';
import { PosBilling } from './Components/pos_billing';
import LandingPageAdsSettings from './Components/settings/landing_page_ads';
import { updatePWAConfig } from './utils/updatePWAConfig';
import CartPage from './Pages/CartPage';
import OrderTrackingPage from './Pages/OrderTrackingPage';
import PaymentSuccess from './Pages/PaymentSuccess';
import { cacheAppConfigForSW } from './utils/cacheAppConfigForSW';
import { prefetchAppConfig, initializeHubFromHostname } from './utils/getAppConfig';
import { getCurrentHubId } from './utils/getAppConfig';
import { UserProfile } from './Components/user_profile/profilepage';
import SavedAddresses from './Components/user_profile/SavedAddresses';
import AddAddress from './Components/user_profile/AddAddress';


function AppContent() {
  const initializationRef = useRef(false);

  //Adding changes
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPopup, setShowInstallPopup] = useState(true); //Adding changes
  //Adding changes

  useEffect(() => {
  const handleBeforeInstallPrompt = (e) => {
    e.preventDefault();

    console.log("Install Prompt Ready");

    setDeferredPrompt(e);

    // show popup automatically
    setShowInstallPopup(true);
  };

  window.addEventListener(
    "beforeinstallprompt",
    handleBeforeInstallPrompt
  );

  return () => {
    window.removeEventListener(
      "beforeinstallprompt",
      handleBeforeInstallPrompt
    );
  };
}, []);

const handleInstallClick = async () => {
  if (!deferredPrompt) return;

  deferredPrompt.prompt();

  const choiceResult = await deferredPrompt.userChoice;

  if (choiceResult.outcome === "accepted") {
    console.log("User accepted install");
  } else {
    console.log("User dismissed install");
  }

  setDeferredPrompt(null);
  setShowInstallPopup(false);
}; //Adding changes


  useEffect(() => {
    // Prevent multiple initializations
    if (initializationRef.current) {
      return;
    }
    
    // Check if we're on an auth page - don't initialize PWA config on login/signup pages
    const currentPath = window.location.pathname;
    const isAuthPage = currentPath === '/' || 
                       currentPath === '/signup' || 
                       currentPath === '/otpVerification' ||
                       currentPath === '/shino-partner';
    
    // Check if user is authenticated
    const access_token = localStorage.getItem('authtoken');
    const refresh_token = localStorage.getItem('refreshToken');
    const isAuthenticated = !!(access_token && refresh_token);
    
    // Only initialize if authenticated and not on auth pages
    if (isAuthPage || !isAuthenticated) {
      // Still update PWA config with defaults (for favicon, etc.)
      updatePWAConfig(false).catch(() => {});
      return;
    }
    
    initializationRef.current = true;
    
    (async () => {
      try {
        let hubId = null;

        const urlMatch = currentPath.match(/\/home\/(?:add_hub|edit_hub)\/(\d+)/);
        if (urlMatch && urlMatch[1]) {
          const urlHubId = parseInt(urlMatch[1], 10);
          if (!isNaN(urlHubId)) {
            hubId = urlHubId;
            localStorage.setItem('selected_hub', urlHubId.toString());
            store.dispatch(updateSelectedHub([urlHubId]));
            // console.log('[App] Extracted hub ID from URL:', urlHubId, 'for path:', currentPath);
          }
        }

        if (!hubId) {
          try {
            hubId = await initializeHubFromHostname();
          } catch (error) {
            // Continue with localStorage hubId if hostname lookup fails
          }
        }

        if (!hubId) {
          hubId = getCurrentHubId();
        }

        if (hubId) {
          localStorage.setItem('selected_hub', hubId.toString());
          store.dispatch(updateSelectedHub([hubId]));
        }

        if (hubId) {
          await prefetchAppConfig(hubId);
        }

        await cacheAppConfigForSW();
        await updatePWAConfig(true);
      } catch (e) {
        await updatePWAConfig(false);
        initializationRef.current = false; // Allow retry on error
      }
    })();
  }, []);

  return (
  
    //Adding changes 
    <>
    {showInstallPopup && (
      <div style={{
        position: "fixed",
        top: "50px",
        left: "40%",
        width:"20%",
        right: "20px",
        background: "#fff",
        padding: "20px",
        borderRadius: "10px",
        boxShadow: "0 0 10px rgba(0,0,0,0.3)",
        zIndex: 9999 
      }}>
        <p>Install SmartKart App?</p>

        <div style={{ display: "flex", gap: "10px" }}>
          <button onClick={handleInstallClick}>
              Install
          </button>

          <button onClick={() => setShowInstallPopup(false)}>
            Cancel
          </button>
        </div>
      </div>
    )};
    
    <BrowserRouter>
      <Routes>
        <Route path="/signup" element={<Signup />} />
        <Route path="/otpVerification" element={<OtpVerification />} />
        <Route path='/' element={<Login />} />
        <Route path='/shino-partner' element={<DPLogin />} />
        <Route path='/dp-home' element={<DPHome />} />
        <Route path='/dp-earnings' element={<DeliveryEarnings />} />
        {/* <Route path='/batchList' element={<InventoryBatchList />} /> */}
        <Route path='/home' element={<Home />} >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="product_details" element={<ProductDetails />} />
          <Route path="campaign" element={<Campaign />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="add_hub" element={<AddHub />} />
          <Route path="add_hub/:id" element={<AddHub />} />
          <Route path="edit_hub/:id" element={<AddHub />} />
          <Route path="vendor_management" element={<VendorManagement />} />
          <Route path="inventoryBatchList" element={<InventoryBatchList />} />
          <Route path="BatchHistory" element={<BatchHistory />} />
          <Route path="general" element={<GeneralSettings />} />
          <Route path="category" element={<Category />} />
          <Route path="sub_category" element={<SubCategory />} />
          <Route path="order_management" element={<OrederManagement />} />
          <Route path="kiosk_order" element={<KioskOrderManagement />} />
          <Route path="pos_billing" element={<PosBilling />} />
          <Route path="offer_management" element={<OfferManagement />} />
          <Route path="delivery_management" element={<DeliveryManagement />} />
          <Route path="weekly_delivery_slots" element={<WeeklyDeliverySlots />} />
          <Route path="suppliers" element={<Suppliers />} />
          <Route path="add_supplier" element={<AddSupplier />} />
          <Route path="edit_supplier/:id" element={<AddSupplier />} />
          <Route path="user_management" element={<UserManagement />} />
          <Route path="Campaign_push_notification" element={<Campaign_Push_notification />} />
          <Route path="app_version_control" element={<AppVersionControlSettings />} />
          <Route path="product_banner" element={<ProductBanner />} />
          <Route path="home_banner" element={<Homebanner />} />
          <Route path="launch_screen" element={<LaunchScreenSettings />} />
          <Route path="landing_page_ads" element={<LandingPageAdsSettings />} />
          <Route path="addinstruction" element={<AddInstructions />} />
          <Route path="franchise" element={<FranchiseManagement />} />
          <Route path="profile_settings" element={<ProfileSettings />} />
        </Route>
        <Route path="/cart" element={<CartPage />} />
        <Route path="/order-tracking/:orderId" element={<OrderTrackingPage />} />
        <Route path="/payment-success/:orderId" element={<PaymentSuccess />} />
        <Route path="/user_profile" element={<UserProfile />} />
        <Route path="/saved-addresses" element={<SavedAddresses />} />
        <Route path="/add-address" element={<AddAddress />} />
        {/* <Route path='dashboard' element={<Dashboard/>} /> */}

      </Routes>
    </BrowserRouter>
    </>
  );
}

function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default App;
